import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={15} height={23} viewBox="0 0 15 23" fill="none" {...props}>
      <Path
        d="M0 23V0l15 10.952L0 23z"
        fill={props?.color ? props.color : "#E40046"}
      />
    </Svg>
  );
}

export default SvgComponent;
